module.exports = __webpack_public_path__ + "static/media/gluck.93931b9a.jpg";